import { CameraAccountIcon } from './CameraAccountIcon';

/**
 * author: Google
 * id E6F67D5D-0EED-450C-B39F-75D37E9B63CA
 * name camera-account
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/camera-account.svg
 * tags
 * - Account / User 
 * - Photography 
 */
export const CameraUserIcon = CameraAccountIcon;
export default CameraUserIcon